import { Button, Dimmer, Header, Loader, Message } from '@mairistem/composants';
import { request } from '@mairistem/tools';
import _ from 'lodash';
import React from 'react';
import { useHistory } from 'react-router';
import { toast } from 'react-toastify';

import { baseUrlFront, deleteRegie } from '@/routes';
import { useRegieStore } from '@/zustand';
import { ModalConfirm } from '../Autre';

const ParametrageQualiteSuppressionRegie = () => {
  const [loading, setLoading] = React.useState<boolean>(false);
  const [confirmModal, setConfirmModal] = React.useState<string>('');

  const regie = useRegieStore((state) => state.regie);
  const setRegie = useRegieStore((state) => state.setRegie);
  const setHasRegies = useRegieStore((state) => state.setHasRegies);

  const history = useHistory();

  const { identifiant, titre } = regie;

  const handleRegieDeleteClick = React.useCallback(() => {
    setConfirmModal('delete-regie');
  }, []);

  const handleConfirmFirst = React.useCallback(() => {
    setConfirmModal('delete-regie-are-you-sure');
  }, []);

  const handleDeletionConfirm = React.useCallback(() => {
    setConfirmModal('delete-regie');
    setLoading(true);

    request
      .delete(deleteRegie(identifiant))
      .then(() => {
        setRegie(null);
        setHasRegies();

        // Redirection vers l'accueil
        history.push(`${baseUrlFront}`);

        toast('La régie a été supprimée', { type: 'success' });
      })
      .catch(() => {
        toast('Une erreur est survenue lors de la suppression de la régie', { type: 'error' });
      })
      .finally(() => {
        setLoading(false);
      });
  }, [history, identifiant, setHasRegies, setRegie]);

  return (
    <>
      <Button
        icon="trash"
        basic
        content="Supprimer la régie complètement"
        loading={loading}
        onClick={handleRegieDeleteClick}
        fluid
      />
      {!_.isEmpty(confirmModal) && (
        <>
          <ModalConfirm
            header={`Confirmation de suppression de ${titre}`}
            onConfirm={handleConfirmFirst}
            onCancel={() => setConfirmModal('')}
            loading={loading}
            content={
              <div style={{ height: 110 }}>
                {loading ? (
                  <Dimmer active={loading} inverted>
                    <Loader inverted>
                      Suppression des données en cours.
                      <br />
                      <br />
                      L&apos;opération peut prendre quelques minutes.
                    </Loader>
                  </Dimmer>
                ) : (
                  <>
                    <Header as="h4">
                      <Header.Content>
                        La régie <span style={{ textDecoration: 'underline' }}>{titre}</span> sera
                        supprimée intégralement.
                      </Header.Content>
                    </Header>
                    <Message error size="small">
                      <Message.Header>Cette action est irréversible.</Message.Header>
                      <Message.Content>
                        <br />
                        Veuillez ne pas cliquer sur ce bouton &quot;juste pour tester&quot;.
                      </Message.Content>
                    </Message>
                  </>
                )}
              </div>
            }
          />
          {confirmModal === 'delete-regie-are-you-sure' && (
            <ModalConfirm
              header="Dernière chance"
              size="tiny"
              confirmText="Oui je le veux"
              cancelText="En fait... Je ne suis pas si sûr"
              onConfirm={handleDeletionConfirm}
              onCancel={() => setConfirmModal('')}
              content={
                <>
                  <Header as="h4">
                    <Header.Content>Êtes vous vraiment sûr ?</Header.Content>
                  </Header>
                  <Message error size="small">
                    <Message.Header>Cette action est vraiment irréversible.</Message.Header>
                  </Message>
                </>
              }
            />
          )}
        </>
      )}
    </>
  );
};

export default ParametrageQualiteSuppressionRegie;
